module.exports = "/_next/static/images/bg-info-extend-1-2506b178.png";